import {
    BaseFeatureArgs,
    InitialQueryState,
    SkipOrArgs,
} from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';

import { useFeatureQuery } from '@common/hooks';
import { useSelectedProductionId } from '@features/productions';
import { useGetClipQuery } from '../api';
import { GetDirectClipArgs } from '../types';

export interface UseClipByIdArgs extends BaseFeatureArgs {
    assetId: string;
}

export const useClipById = (
    _initialArgs: InitialQueryState = {},
    args: SkipOrArgs<UseClipByIdArgs>,
) => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetDirectClipArgs> = useMemo(() => {
        if (args === skipToken || !args.assetId || !productionId)
            return skipToken;

        return {
            productionId,
            assetId: args.assetId,
            queryParams: {
                includeMediaObject: true,
                includeMediaObjectInstanceType: [
                    'RAW',
                    'PROXY',
                    'HDR_PROXY',
                    'ATTACHMENT',
                    'STITCH',
                ],
                includeMediaObjectWorkflowReportType: [
                    'INGEST',
                    'VOLDEMORT_SPEECH',
                ],
            },
        };
    }, [args, productionId]);

    const { data, ...queryResult } = useFeatureQuery(
        {},
        useGetClipQuery,
        queryArgs,
    );

    return {
        data: Array.isArray(data) ? data[0] : data,
        ...queryResult,
    };
};
